import { format_date } from "helpers/datetime_helper"

export const getAvailableDatesByDeliveryType = (data: any, deliveryType: string) => {
    const dates = []

    const shippingTypes = data?.shippingType?.HD || []

    for (const option of shippingTypes) {
      for (const schedule of option.schedules || []) {
        if (schedule?.deliveryType === deliveryType) {
          for (const date of schedule?.dates || []) {
            dates.push({
              label: format_date(date.delivery),
              value: date.delivery,
            })
          }
        }
      }
    }

    return dates || []
  }